import type { ConfigType } from '@plone/registry';
import BackToTop from '../components/BackToTop/BackToTop';

export default function install(config: ConfigType) {
  // Language settings
  // The site is multilingual (PT-BR + EN, with room for more languages later).
  // UI strings live in English in the code and are translated via locale files.
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['pt-br', 'en'];
  config.settings.defaultLanguage = 'pt-br';

  // Botão flutuante "voltar ao topo" em todas as rotas
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    { match: '', component: BackToTop },
  ];

  return config;
}
